import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import React from 'react'
import QRCode from 'react-qr-code'
import { useReaderContext } from '../../../Contexts/Modules/ReaderModule/ReaderModule'
import { Clear } from '@mui/icons-material'

function ModalClear() {
  const { confirmClear, openClear, setOpenClear, setConfirmClear } =
    useReaderContext()

  return (
    <>
      <Button
        variant={'outlined'}
        startIcon={<Clear />}
        color={'error'}
        onClick={() => setOpenClear(true)}
      >
        Reader
      </Button>
      <Dialog open={openClear}>
        <DialogTitle>
          {!confirmClear ?
            'Are you sure you wish to clear the reader?'
          : 'Scan to clear reader memory'}
        </DialogTitle>
        <DialogContent>
          {confirmClear && (
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ mr: 1 }}>
                <Typography variant="body2">Scan QR code to clear</Typography>
                <Typography variant="body2">all data in storage</Typography>
              </Box>
              <QRCode
                size={100}
                style={{ height: '100px', width: '100px' }}
                value={'%%SpecCode18'}
                viewBox={`0 0 256 256`}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {confirmClear ?
            <Button
              onClick={() => {
                setOpenClear(false)
                setConfirmClear(false)
              }}
            >
              Close
            </Button>
          : <Box
              width={1}
              justifyContent={'space-between'}
              display={'flex'}
              p={1}
            >
              <Button
                onClick={() => {
                  setOpenClear(false)
                  setConfirmClear(false)
                }}
                color="error"
                variant={'outlined'}
              >
                No
              </Button>
              <Button
                onClick={() => setConfirmClear(true)}
                variant={'outlined'}
              >
                Yes
              </Button>
            </Box>
          }
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ModalClear
